"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
var react_1 = __importDefault(require("react"));
var Paragraph = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("p", { className: "leading-normal mb-2" }, children));
};
exports.Paragraph = Paragraph;
